import { defineStore } from 'pinia';
import { getCookies, removeCookie, setCookie } from '@services/Common';
import { api } from '@services/AxiosBootstrap';
import { useAppStore } from '@stores/App';

const LOCAL_STORAGE_KEY = 'user-state';
const COOKIE_NAME = 'my_newport_token';

const getDefaultState = () => {
    return {
        id: null,
        first_name: null,
        last_name: null,
        name: null,
        email: null,
        needs_email: true,
        email_verified_at: null,
        voyado_id: null,
        created_at: null,
        updated_at: null,
        token: null,
        last_saved: null,
        cookie: null,
        last_login_path: null,
        redirect_to: null,
    };
}

const getStoredState = () => {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
}

export const useUserStore = defineStore('user', {
    state: () => {
        return getStoredState() || getDefaultState();
    },
    getters: { // like computed props
        needsMailVerification: (state) => {
            return state.email_verified_at === null;
        },
        needsEmail(state) {
            return state.email.includes('@newport.temp');
        },
    },
    actions: { // like normal methods
        isLoggedIn() {
            const token = this.getCookieToken();

            if (token && this.$state.id === null) {
                this.$patch({token: atob(token)});
            }

            return this.getCookieToken()?.length > 1;
        },
        async refresh() {
            try {
                const response = await api.get('/auth/account');
                this.$patch(response.data);
                this.saveState();
            } catch (e) {
                if (e?.response?.status === 401) {
                    this.logout();
                    this.$router.push('/login');
                    return;
                }
                throw e;
            }
        },
        needsRefresh() {
            if (!this.recoverState()) {
                return true;
            }

            const state = this.$state;
            const now = new Date();
            const diff = Math.abs(new Date(state.last_saved) - now) / 1000;
            return diff > (60);
        },
        login(loginResponse, redirectTo = null) {
            debugger;
            this.$patch(loginResponse.user);
            this.addToken(
                loginResponse.auth,
            );
            this.saveState();

            if (redirectTo && this.isLoggedIn()) {
                return location.href = redirectTo;
            }

            if (this.redirect_to) {
                const to = this.redirect_to;
                this.redirect_to = null;
                return this.$router.push(to);
            }

            return this.$router.push('/account/wedding-list/create');
        },
        addToken(auth) {
            const token = auth.token;
            const cookie = auth.cookie;
            this.$patch({token: atob(token), cookie: cookie});
            this.saveState();
        },
        saveState() {
            this.$patch({ last_saved: (new Date()).toISOString() });
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.$state));
        },
        recoverState() {
            return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
        },
        getCookieToken() {
            return getCookies()[COOKIE_NAME];
        },
    },
});
